<template>
  <div class="college-advantages">
    <website-header :setNum="2" :setChildNum="1"></website-header>
    <div class="index-top display-flex justify-content-center align-items-center" :style="`background-image:url('${imgURI + '/static/college/Intro/BJ1.png'}');`">
      <div class="index-top-msg display-flex justify-content-center align-items-center">
        <div class="c bold">学院优势</div>
        <div class="e">College Advantages</div>
      </div>
    </div>
    <div class="college-content">
      <img :src="`${imgURI}/static/college/advantages/kankan.png`" style="position: absolute;width: 100%;margin-top: -68px"/>
      <div style="position: relative">
        <div class="business-tips def-width margin-center" style="margin-bottom: 30px">
          <div class="tips-bor">
            <div class="c">师资强大</div>
            <div class="font-18 color-D2D2D2">STRONG TEACHING STAFF</div>
          </div>
          <div class="line"></div>
        </div>
        <ul class="user-ul def-width display-flex justify-content-center text-center margin-center">
          <li>
            <img :src="`${imgURI}/static/college/advantages/moss.png`"/>
            <div class="name">Moss</div>
            <div class="font-18">侃侃、白鹿会创始人</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/soju.png`"/>
            <div class="name">Soju</div>
            <div class="font-18">千万级广告操盘手</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/georgeyoung.png`"/>
            <div class="name">George Young</div>
            <div class="font-18">上市卖家操盘手</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/WEN.png`"/>
            <div class="name">George Wen</div>
            <div class="font-18">10亿级卖家CEO</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/Karen.png`"/>
            <div class="name">Karen</div>
            <div class="font-18">14年独立站操盘经验</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/Ana.png`"/>
            <div class="name">Ana</div>
            <div class="font-18">粉丝15W IG红人 </div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/chris.png`"/>
            <div class="name">Chris</div>
            <div class="font-18">17年用户研究经验</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/guoxuhua.png`"/>
            <div class="name">郭旭华</div>
            <div class="font-18">清华特聘薪酬绩效专家</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/Angela.png`"/>
            <div class="name">Angela</div>
            <div class="font-18">百亿大卖内训讲师</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/linxiongwei.png`"/>
            <div class="name">林雄伟</div>
            <div class="font-18">TikTok头部大卖</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/matt.png`"/>
            <div class="name">Matt</div>
            <div class="font-18">美国本土跨境大卖</div>
          </li>
        </ul>
        <img style="width: 100%" :src="`${imgURI}/static/college/advantages/neirong.png`"/>
        <div class="business-tips def-width margin-center">
          <div class="tips-bor">
            <div class="c">运营服务</div>
            <div class="font-18 color-D2D2D2">OPERATIONS SERVICES</div>
          </div>
          <div class="line"></div>
        </div>
        <ul class="operations display-flex justify-content-center text-center margin-center">
          <li>
            <img :src="`${imgURI}/static/college/advantages/Icon1.png`">
            <div class="title">客户为导向 、专业运营团队</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/Icon2.png`">
            <div class="title">一对一销售咨询、答疑、售后</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/advantages/Icon3.png`">
            <div class="title">7x24小时客户服务</div>
          </li>
        </ul>
        <div class="business-tips def-width margin-center">
          <div class="tips-bor">
            <div class="c">课程丰富</div>
            <div class="font-18 color-D2D2D2">RICH CURRICULUM</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="rich-bor def-width display-flex justify-content-between margin-center">
          <img class="rich-img" :src="`${imgURI}/static/college/advantages/kecheng.png`">
          <div class="rich-code display-flex justify-content-end text-center">
            <div class="img-bor">
              <img :src="`${imgURI}/static/college/advantages/erweima1.png`">
              <div>讲师合作</div>
            </div>
            <div class="img-bor">
              <img :src="`${imgURI}/static/college/advantages/erweima2.png`">
              <div>课程咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
export default {
  name: "collegeAdvantages",
  components: {WebsiteBot, WebsiteHeader},
  data () {
    return {
      imgURI: config.imgURI
    }
  }
}
</script>

<style lang="scss" scoped>
.college-advantages{
  .index-top{
    margin-top: 100px;
    width: 100%;
    height: 650px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .index-top-msg{
      flex-direction: column;
      color: #FFFFFF;
      width: 460px;
      height: 260px;
      background: rgba(0,0,0,0.4);
      .c{
        letter-spacing: 4px;
        font-size: 60px;
      }
      .e{
        margin-top: 10px;
        font-weight: lighter;
        font-size: 36px;
      }
    }
  }
  .college-content{
  }
  .business-tips{
    margin: 70px auto 124px auto;
    .tips-bor{
      padding-bottom: 13px;
      width: 400px;
      border-bottom: 1px solid #D2D2D2;
      letter-spacing: 1px;
      .c{
        font-size: 40px;
        letter-spacing: 8px;
      }
    }
    .line{
      position: relative;
      top: -5px;
      width: 78px;
      height: 4px;
      background: #386BF3;
    }
  }
  .user-ul{
    margin-bottom: 120px;
    flex-wrap: wrap;
    li{
      cursor: pointer;
      padding: 30px 60px;
      .name{
        margin: 10px 0 4px 0;
        font-weight: bold;
        font-size: 22px;
      }
      img{
        border: 1px solid #D2D2D2;
      }
    }
    li:hover{
      .name{
        color: #386BF3;
      }
      img{
        box-shadow: 0 0 14px #ccc;
        border: 1px solid #386BF3;
      }
    }
  }
  .operations{
    margin-bottom: 200px;
    li{
      margin: 0 90px;
      .title{
        font-size: 18px;
        margin-top: 28px;
      }
    }
  }
  .rich-bor{
    margin-bottom: 100px;
  }
  .rich-img{
    width: 980px;
  }
  .rich-code{
    flex-direction: column;
    .img-bor{
      margin-bottom: 58px;
    }
    img{
      margin-bottom: 11px;
      padding: 2px;
      width: 76%;
      border: 1px solid #707070;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/college/advantages.vue